const medicareQuotes = [
  'Whether you are new to Medicare, getting ready to sign up, or you have had Medicare, we make selecting the right supplemental insurance as easy as possible.',
  'We give you access to the most affordable plans in your area from the most recognized insurance carriers, all in one place.'
]

export default medicareQuotes